<template>
    <div class="p-4">
        <div class="cs-border-priamry mb-3 font-size-12 mb-4">
            {{ $t('esim_guideline_activate_title') }}
        </div>
        <div class="mb-3">
            <div class="">
                <div class="d-flex justify-content-start align-items-center w-100 gap-1">
                    <img src="@/static/profile-2.png" alt="prfile" height="25px">
                    <div class="cs-bg-title">
                        <p class="">{{ $t('esim_on_ios_devices') }}</p>
                    </div>
                </div>
                <div class="py-3 cs-list-guide">
                    <ul class="p-0 mb-0">
                        <li>1. {{ $t('esim_guideline_ios_step1') }}</li>
                        <li>2. {{ $t('esim_guideline_ios_step2') }}</li>
                        <li>3. {{ $t('esim_guideline_ios_step3') }}</li>
                        <li>4. {{ $t('esim_guideline_ios_step4') }}</li>
                        <li>5. {{ $t('esim_guideline_ios_step5') }}</li>
                    </ul>
                </div>
            </div>
            <div class="">
                <div class="d-flex justify-content-start align-items-center w-100 gap-1">
                    <img src="@/static/profile-2.png" alt="prfile" height="25px">
                    <div class="cs-bg-title">
                        <p class="">{{ $t('esim_on_android_devices') }}</p>
                    </div>
                </div>
                <div class="py-3 cs-list-guide">
                    <ul class="p-0 mb-0">
                        <li>1. {{ $t('esim_guideline_android_step1') }}</li>
                        <li>2. {{ $t('esim_guideline_android_step2') }}</li>
                        <li>3. {{ $t('esim_guideline_android_step3') }}</li>
                        <li>4. {{ $t('esim_guideline_android_step4') }}</li>
                        <li>5. {{ $t('esim_guideline_android_step5') }}</li>
                        <li>6. {{ $t('esim_guideline_android_step6') }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CONSTANTS } from "@/helpers/constants";
import { mapState } from "vuex";

export default {
    name: 'ESupport',
    computed: {
        ...mapState("headerStore", ["title"]),
    },
    mounted() {
        this.changeTitle(this.$t(this.title));
    },
    watch: {
        $route: {
            handler: function (value) {
                this.$store.dispatch("headerStore/setTitle", "esim_help");
            },
            immediate: true,
        },
    },
    methods: {
        color_primary() {
            return CONSTANTS.color_primary;
        },
        changeTitle(title) {
            const contentData = {
                title: title,
                color: "#ffffff",
                bgColor: this.color_primary(),
            };
            this.$bridge.callHandler("setBarTitle", contentData).then((data) => { });
        },
    }
}

</script>
<style>
.cs-border-priamry {
    /* border: 1px solid #C41627; */
    border-radius: 10px;
    width: 100%;
    padding: 15px;
    text-align: center;
    text-transform: uppercase;
    color: #C41627;
    font-weight: bold;
}

.cs-bg-title {
    min-width: 70%;
    background-color: #C41627;
    clip-path: polygon(100% 0, 100% 49%, 100% 100%, 0% 100%, 5px 50%, 0% 0%);
    height: 26px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 5px 30px 5px 20px;
    font-size: 11px;
    font-weight: bold;
    display: flex;
    justify-content: start;
    align-items: center;
    height: fit-content;
}

.cs-bg-title>p {
    color: #fff;
    text-transform: uppercase;
    margin: 0;
}

.cs-list-guide {
    padding: 10px;
}

.cs-list-guide ul li {
    font-size: 11px;
    font-weight: bold;
}
</style>
